module.exports = __webpack_public_path__ + "static/media/Group92.d3be4c6a.png";